// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3TG-Y","buttons":"Footer_buttons__lFssr"};